import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Container from './presentation/Container';
import Notification from './presentation/Notification';


class App extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  render() {
    if( this.state.hasError === false ) {
      return (
        <span>
          <Notification />
          <Container />
        </span>
      );
    } else {
      return (
        <div>TODO: Error component here</div>
      );
    }
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag,
        user: store.user
      };
    }
  )( App ) );



// WEBPACK FOOTER //
// ./src/App.js